import api from './api';

export type AppVersionResponse = {
  appName?: string | null;
  version?: string | null;
  buildTimestamp?: string | null;
};

export const getAppVersion = async (): Promise<AppVersionResponse> => {
  const response = await api.get<AppVersionResponse>('/meta/version', {
    params: { _: Date.now() },
  });
  return response.data ?? {};
};
